import React from 'react';

const CHUNK_RELOAD_FLAG = 'zone_chunk_reload_attempt';

function isChunkLoadError(error) {
  if (!error) return false;
  if (error.name === 'ChunkLoadError') return true;
  const msg = String(error.message || '');
  return /loading chunk [\da-z._-]* failed/i.test(msg);
}

/**
 * Prefer PerformanceNavigationTiming so we reload once per deploy mismatch without
 * sessionStorage sticking across reloads (which skipped the recovery reload).
 */
function shouldReloadPageForChunkError() {
  try {
    const nav = performance.getEntriesByType?.('navigation')?.[0];
    if (nav && typeof nav.type === 'string') {
      return nav.type !== 'reload';
    }
  } catch {
    // ignore
  }
  if (!sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
    return true;
  }
  sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
  return false;
}

/**
 * React.lazy wrapper: after a deploy, long-lived tabs still run an old main bundle
 * that references removed chunk hashes → ChunkLoadError on first navigation to a
 * lazy route. One full reload fetches fresh index.html + assets.
 */
export function lazyWithChunkReload(importFn) {
  return React.lazy(async () => {
    try {
      const mod = await importFn();
      sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
      return mod;
    } catch (error) {
      if (!isChunkLoadError(error) || typeof window === 'undefined') throw error;
      if (shouldReloadPageForChunkError()) {
        window.location.reload();
        return await new Promise(() => {});
      }
      throw error;
    }
  });
}
